import { User } from "@/models/user";

function getUser(): User | null {
  const userString = window.localStorage.getItem("user");
  if (!userString) {
    return null;
  }

  const user = JSON.parse(userString);
  user.username = user["cognito:username"];
  user.groups = user["cognito:groups"];
  user.admin = !!(user["custom:admin"] && user["custom:admin"] == "1");

  return user as User;
}

function getDocumentationBaseUrl(): string {
  const docUrl = window.localStorage.getItem("Documentation:url");
  if (docUrl !== null) {
    return docUrl;
  }
  return "";
}
function getSignedCookieBaseUrl(): string {
  const Policy = localStorage.getItem("CloudFront-Policy");
  const Signature = localStorage.getItem("CloudFront-Signature");
  const KeyPairId = localStorage.getItem("CloudFront-Key-Pair-Id");

  return "?Policy=" + Policy + "&Signature=" + Signature + "&Key-Pair-Id=" + KeyPairId;
}

export { getUser, getDocumentationBaseUrl, getSignedCookieBaseUrl };
